import { createTheme } from "@mui/material/styles";
import merge from "lodash.merge";
import { theme as permisTheme } from "./permisTheme";
import { theme as proTheme } from "./proTheme";

export const theme = merge({}, permisTheme, proTheme, {});

export default createTheme(theme);
